import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { TrailerService } from 'src/app/services/app/trailer.service';
import { UtilitieService } from 'src/app/services/utils/utilities.service';
import { Yard, YardService, YardStatus, YardUpdateOption } from 'src/app/services/app/yard.service';
import { WebsocketService } from 'src/app/services/utils/websocket.service';

@Component({
  selector: 'add-spot',
  templateUrl: './add-spot.component.html',
  styleUrls: ['./add-spot.component.css'],
})
export class AddSpotComponent implements OnInit {

  @ViewChild('addSpotFormSubmitBtn')
  addSpotFormSubmitBtn: MatButton;
  @ViewChild('addTrailerFormSubmitBtn')
  addTrailerFormSubmitBtn: MatButton;
  targetSpot: Yard;
  hasTrailer: boolean = false;
  viewMode: string = 'trailerView';
  trailerStatus: string[] = [];
  allYardSpots: Yard[] = [];
  openYardSpots: Yard[] = [];
  takenYardSpots: Yard[] = [];
  isLoading: boolean = false;


  constructor(private yardService: YardService, private trailerService: TrailerService, private utilService: UtilitieService, private websocketService: WebsocketService) { }

  switchView() {
    this.viewMode = this.viewMode == 'trailerView' ? 'yardView' : 'trailerView';
    if (this.viewMode === 'yardView') {
      this.targetSpot.location = this.generateNewYardLocation();
    } else {
      this.targetSpot.location = '';
    }
  }
  /**
   * function used to auto increment yard locations and avoid an repeats.
   * The toString() postion is necessary because location is displayed as a nuber and althouh the type is set up for
   * a string the type gets switched to a number
   */
  private generateNewYardLocation() {
    return this.yardService.genUUID();
  }
  checkIfYardExist(): boolean {
    return this.allYardSpots.some((yardSpot) => {
      return yardSpot.location === this.targetSpot.location;
    });
  }
  async checkInTrailer(form: NgForm) {
    this.addTrailerFormSubmitBtn.disabled = true;
    let yardSpot: Yard = this.setUpYardFromFormData(form, YardStatus.OCCUPIED);

    const result = await this.yardService.updateYard(YardUpdateOption.ASSIGN, yardSpot);
    if (result) {

      this.utilService.openSnackBar('Data saved succesfully', '');
      this.initTargetSpot();
      form.resetForm();

      this.addTrailerFormSubmitBtn.disabled = false;
      let index: number = this.openYardSpots.findIndex((yard) => {
        return yard.location === yardSpot.location;
      });
      this.openYardSpots.splice(index, 1);
    } else {
      this.utilService.openSnackBar(
        'There was an issue saving data',
        'Please try again!'
      );
    }
  }

  async addSpot(form: NgForm) {
    // getting data from form
    this.addSpotFormSubmitBtn.disabled = true;
    let yardSpot: Yard;
    if (this.hasTrailer) {
      this.setUpYardFromFormData(form, YardStatus.OCCUPIED);

    } else {
      yardSpot = this.setUpYardFromFormData(form, YardStatus.EMPTY);
      // no trailer is included here
      yardSpot.trailerId = null;
    }

    const result = await this.yardService.updateYard('ASSIGN', yardSpot);
    if (result) {
      this.allYardSpots.push(yardSpot);
      this.utilService.openSnackBar('Data saved succesfully', '');
      this.initTargetSpot();
      form.resetForm();
      //TODO has trailers reset completely when form is reset find solution
      // everything gets rest with resetForm so it need to be reinitialized
      this.hasTrailer = true;
      this.targetSpot.location = this.generateNewYardLocation();
    } else {
      this.utilService.openSnackBar(
        'There was an issue saving data',
        'Please try again!'
      );
    }
    this.addSpotFormSubmitBtn.disabled = false;
    this.allYardSpots.push(yardSpot);
  }

  private setUpYardFromFormData(form: NgForm, yardStatus: YardStatus): Yard {
    // getting data from form
    let data = form.value;

    let yardSpot: Yard = {
      id: '',
      location: this.targetSpot.location,
      status: yardStatus,
      trailerId: '',
      instance: 0,
      trailer: {
        id: null,
        location: this.targetSpot.location,
        trailer: data.trailerNumber,
        carrier: data.carrier,
        status: data.status,
        po: data.po,
        instance: 0
      },

    };
    return yardSpot;
  }

  private initTargetSpot() {
    // instanciating the target spot in case this method is called more than once.
    this.targetSpot = new Yard();
  }

  async ngOnInit(): Promise<void> {
    this.utilService.updateLoading(true);
    this.trailerStatus = this.trailerService.getAllTrailerStatus();

    this.initTargetSpot();
    const allPage = await this.yardService.getAllYardSpots(0, 10);
    this.allYardSpots = allPage.data;

    this.openYardSpots = await this.yardService.getAllOpenYards();
    this.utilService.updateLoading(false);
  }


}
